import React from 'react';

import { FightProvider } from './Fight';
import { ActionsProvider } from './Actions';
import { KeyProvider as ActionKeysHandlerProvider } from './ActionKeys';
import FightKeysHandlerProvider from './FightKeys';
import { AuthProvider } from './Auth';
import { HeaderProvider } from './Header';
import { ServicesInitializer } from './ServicesInitializer';
import { RabbitStompProvider } from './RabbitStompProvider';

const hooks: React.FC = ({ children }) => (
  <AuthProvider>
    <ServicesInitializer>
      <RabbitStompProvider>
        <HeaderProvider>
          <FightProvider>
            <ActionsProvider>
              {/* KeyProvider por fora: é ele que mantém o estado de "modal
                  aberto", e o FightKeys precisa lê-lo para bloquear o teclado. */}
              <ActionKeysHandlerProvider>
                <FightKeysHandlerProvider>{children}</FightKeysHandlerProvider>
              </ActionKeysHandlerProvider>
            </ActionsProvider>
          </FightProvider>
        </HeaderProvider>
      </RabbitStompProvider>
    </ServicesInitializer>
  </AuthProvider>
);

export default hooks;

export { useRabbitStompContext, useRabbitStompInstance, RabbitStompProvider } from './RabbitStompProvider';

export { useSocketV1, useSocketV1Instance } from './SocketV1';

export { useSocketV2, useSocketV2Instance } from './Socket';

export { ServicesInitializer, useServicesStatus, useServicesReady, useWaitForServices } from './ServicesInitializer';
